(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-wu-header]').forEach(header => {
      if (header.dataset.uiReady) return;
      header.dataset.uiReady = 'true';
      const mobileButton = header.querySelector('.wu-header__mobile-toggle');
      const items = Array.from(header.querySelectorAll('.has-mega'));
      const desktop = window.matchMedia('(min-width: 990px)');
      const openItem = (item, open, source = 'click') => {
        item.dataset.open = String(open);
        item.dataset.openByHover = String(open && source === 'hover');
        item.querySelector('.wu-header__nav-toggle')?.setAttribute('aria-expanded', String(open));
      };
      const closeItems = () => items.forEach(item => openItem(item, false));
      const setMobile = (open, restoreFocus = false) => {
        if (!open && !header.classList.contains('mobile-open')) return;
        mobileButton?.setAttribute('aria-expanded', String(open));
        header.classList.toggle('mobile-open', open);
        document.body.classList.toggle('wu-menu-open', open);
        header.style.setProperty('--wu-menu-height', `${window.innerHeight - header.getBoundingClientRect().bottom}px`);
        [document.getElementById('MainContent'), document.querySelector('.wu-footer')].forEach(element => {
          if (element) element.inert = open;
        });
        if (!open && restoreFocus) mobileButton?.focus();
      };
      mobileButton?.addEventListener('click', () => setMobile(mobileButton.getAttribute('aria-expanded') !== 'true'));
      items.forEach(item => {
        const toggle = item.querySelector('.wu-header__nav-toggle');
        toggle?.addEventListener('click', () => {
          const open = item.dataset.open !== 'true' || item.dataset.openByHover === 'true';
          closeItems();
          openItem(item, open);
        });
        item.addEventListener('pointerenter', event => {
          if (desktop.matches && event.pointerType === 'mouse') {
            closeItems();
            openItem(item, true, 'hover');
          }
        });
        item.addEventListener('pointerleave', () => {
          if (!item.contains(document.activeElement)) openItem(item, false);
        });
        item.addEventListener('focusout', event => {
          if (!item.contains(event.relatedTarget)) openItem(item, false);
        });
      });
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const active = items.find(item => item.dataset.open === 'true');
          closeItems();
          if (header.classList.contains('mobile-open')) setMobile(false, true);
          else active?.querySelector('.wu-header__nav-toggle')?.focus();
        }
        if (event.key === 'Tab' && header.classList.contains('mobile-open')) {
          const controls = Array.from(header.querySelectorAll('a,button,summary')).filter(element => element.getClientRects().length);
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      header.addEventListener('click', event => {
        if (event.target.closest('a') && header.classList.contains('mobile-open')) setMobile(false);
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) { closeItems(); setMobile(false); }
      });
      desktop.addEventListener('change', () => { closeItems(); setMobile(false); });
    });
    root.querySelectorAll('[data-wu-video]').forEach(container => {
      if (container.dataset.uiReady) return;
      container.dataset.uiReady = 'true';
      const video = container.querySelector('video');
      const button = container.querySelector('.wu-video-toggle');
      if (!video || !button) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const label = () => {
        button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        button.setAttribute('aria-label', button.textContent);
      };
      if (reducedMotion.matches) video.pause();
      video.addEventListener('play', label);
      video.addEventListener('pause', label);
      button.addEventListener('click', () => video.paused ? video.play().catch(label) : video.pause());
      reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) video.pause(); });
      label();
    });
    root.querySelectorAll('.wu-collection__quick-toggle').forEach(button => {
      if (button.dataset.uiReady) return;
      button.dataset.uiReady = 'true';
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.querySelector('span').textContent = open ? '−' : '+';
      });
    });
    root.querySelectorAll('[data-wu-sort]').forEach(select => {
      if (select.dataset.uiReady) return;
      select.dataset.uiReady = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
